export default __webpack_public_path__ + "static/media/guesty_lite_step2.04e392e5.png";